import { message } from "antd";
import endpoints from "../utils/endpoints";
import { removeEmpty } from "../utils/objectUtils";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";

export async function getDrawerManagementList(params?: any) {
  let res:any[] = []
  if(params) {
    params = removeEmpty(params)
  }
  await Api.get(endpoints.getDrawerManagement, {params}).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError(`Could not get drawer management list`)
  })

  return res
}

export async function saveDrawerManagement(payload: any) {
  await Api.post(endpoints.saveDrawerManagement, payload).then((response) => {
    if(response.status === 200 || response.data.return) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces(`Drawer management successfully updated`)
      }
    }
  }).catch((err: string) => {
    notificationError(`Could not update drawer management list`)
  })
}